export default __webpack_public_path__ + "static/split-puzzle-c621464fd55a1392705123c52fba12ee.gif";